import {
    removeItemBasket,
    removeItemBasketClone,
    updateItemCountBasket,
    updateItemCountBasketClone
} from '../Redux/Reducers/shopReducer';

export const buildBasketCounterReducerAction = (data, basketID, cloneid = false) => {
    const isClone = cloneid !== false && cloneid !== 'false';

    if (data?.status === 'changed' || data?.status === 'set') {
        return isClone
            ? updateItemCountBasketClone(basketID, Number(data.count))
            : updateItemCountBasket(basketID, Number(data.count));
    }

    if (data?.status === 'delete') {
        return isClone
            ? removeItemBasketClone(basketID)
            : removeItemBasket(basketID);
    }

    return null;
};
